export const RANK_THRESHOLDS = [
  { rank: 'Sovereign', points: 5000, badge: '\u{1F451}', color: '#E8C547', glow: true },
  { rank: 'Philosopher', points: 2500, badge: '\u25C9', color: '#C9A84C', shimmer: true },
  { rank: 'Architect', points: 1000, badge: '\u2727', color: '#D4A574', glow: true },
  { rank: 'Builder', points: 400, badge: '\u2B21', color: '#8B6914' },
  { rank: 'Thinker', points: 150, badge: '\u25C8', color: '#C9A84C' },
  { rank: 'Observer', points: 50, badge: '\u2726\u2726', color: '#A67C00' },
  { rank: 'Seeker', points: 0, badge: '\u2726', color: '#9C8B7A' },
];

export function getRankInfo(rank) {
  return RANK_THRESHOLDS.find(r => r.rank === rank) || RANK_THRESHOLDS[RANK_THRESHOLDS.length - 1];
}

export function RankBadge({ rank, size = 'sm' }) {
  const info = getRankInfo(rank);
  const sizeClass = size === 'lg' ? 'text-lg px-3 py-1' : size === 'md' ? 'text-sm px-2 py-0.5' : 'text-xs px-1.5 py-0.5';

  return (
    <span
      data-testid={`rank-badge-${rank?.toLowerCase()}`}
      className={`inline-flex items-center gap-1 rounded-full ${sizeClass} font-body`}
      style={{
        color: info.color,
        background: `${info.color}15`,
        border: `1px solid ${info.color}30`,
        ...(info.glow ? { boxShadow: `0 0 8px ${info.color}30` } : {}),
      }}
    >
      <span>{info.badge}</span>
      <span className="font-medium">{rank}</span>
    </span>
  );
}
